import React from "react";
import {t} from "../../I18n/i18n";

const ValidationExpired = () => {
    return <div className="center">
        <h3>{t("ACCOUNT.VALIDATION.EXPIRED")}</h3>
    </div>
}

export default ValidationExpired;